<template>
  <v-container max-width="420" class="py-10">
    <div class="text-center mb-8">
      <p class="brand-kicker text-primary mb-3">Le Coq Manu</p>
      <v-icon size="56" color="primary">mdi-account-plus-outline</v-icon>
      <h1 class="text-h4 font-weight-bold mt-3">Créer un compte</h1>
      <p class="text-body-2 mt-2 mb-0">
        Rejoignez Le Coq pour suivre vos rappels
      </p>
    </div>

    <v-card>
      <v-card-text class="pa-6">
        <v-form @submit.prevent="handleRegister">
          <v-text-field
            v-model="email"
            label="E-mail"
            type="email"
            prepend-inner-icon="mdi-email-outline"
            density="compact"
            class="mb-3"
            autocomplete="email"
          />

          <v-text-field
            v-model="password"
            label="Mot de passe"
            :type="showPassword ? 'text' : 'password'"
            prepend-inner-icon="mdi-lock-outline"
            :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            density="compact"
            class="mb-3"
            autocomplete="new-password"
            hint="12 caractères minimum"
            persistent-hint
            @click:append-inner="showPassword = !showPassword"
          />

          <v-text-field
            v-model="confirmPassword"
            label="Confirmer le mot de passe"
            :type="showPassword ? 'text' : 'password'"
            prepend-inner-icon="mdi-lock-check-outline"
            density="compact"
            class="mb-4"
            :error-messages="confirmError"
            autocomplete="new-password"
          />

          <v-alert
            v-if="errorMsg"
            type="error"
            variant="tonal"
            density="compact"
            class="mb-4"
          >
            {{ errorMsg }}
          </v-alert>

          <v-btn
            type="submit"
            color="primary"
            block
            :loading="loading"
          >
            Créer mon compte
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>

    <p class="text-center text-body-2 mt-4">
      Déjà un compte ?
      <RouterLink to="/login" class="text-primary text-decoration-none font-weight-medium">
        Se connecter
      </RouterLink>
    </p>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { RouterLink, useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth'

export default defineComponent({
  name: 'RegisterView',
  components: { RouterLink },

  setup() {
    const router          = useRouter()
    const auth            = useAuthStore()
    const email           = ref('')
    const password        = ref('')
    const confirmPassword = ref('')
    const loading         = ref(false)
    const errorMsg        = ref('')
    const confirmError    = ref('')
    const showPassword    = ref(false)

    async function handleRegister(): Promise<void> {
      errorMsg.value    = ''
      confirmError.value = ''

      if (password.value !== confirmPassword.value) {
        confirmError.value = 'Les mots de passe ne correspondent pas.'
        return
      }

      loading.value = true

      try {
        await auth.register(email.value, password.value)
        router.push({ name: 'search' })
      } catch (err) {
        errorMsg.value = err instanceof Error ? err.message : 'Une erreur est survenue.'
      } finally {
        loading.value = false
      }
    }

    return {
      email, password, confirmPassword,
      loading, errorMsg, confirmError, showPassword,
      handleRegister,
    }
  },
})
</script>
